/* eslint-disable prefer-const */
import React from 'react';
import ChartBars from './ChartBars';
import {
  IBilledByDayData,
  IBilledByDayProduct
} from '../../../../../store/ducks/dashboard/types';
import { Column } from '@gerdau/hefesto-mais-web/_shared/graph/graph.types';
import { getColorsChartBarsJson } from '../../../../../utils/ColorsChartBars';
import { Container } from './styles';
interface IBilledByDayChartProps {
  data: IBilledByDayData[];
  allProductsDescription: string[];
  isEmpty: boolean;
}

interface IChartData {
  date: string;
}

const BilledByDayChart: React.FC<IBilledByDayChartProps> = ({
  data,
  allProductsDescription,
  isEmpty
}) => {
  const chartData: IChartData[] = [];

  data.forEach((item) => {
    let newChartData: IChartData = {
      date: item.date.slice(0, 2)
    };

    item.products.forEach((product: IBilledByDayProduct) => {
      newChartData = {
        ...newChartData,
        [product.divisionDescription]: product.billedToday
      };
    });

    chartData.push(newChartData);
  });

  const columns: Column[] = [
    {
      dataKey: '',
      dataKeyTitle: '',
      colors: {
        variant: 'primary',
        tone: '100'
      }
    }
  ];

  const getColumns = () => {
    let productColorsJson: { [x: string]: Column[] } = {};
    let aux: Column[] = [];
    allProductsDescription.forEach((product, idx) => {
      let color = getColorsChartBarsJson(idx);
      let column = {
        dataKey: product,
        dataKeyTitle: product,
        colors: color,

        ...productColorsJson
      };
      aux.push(column);
    });
    return aux;
  };

  return (
    <Container>
      <ChartBars
        chartData={chartData}
        columns={isEmpty ? columns : getColumns()}
        isEmpty={isEmpty}
      />
    </Container>
  );
};

export default BilledByDayChart;
